<div id="dept-geography" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Geography</h2>
    <p class="inner-lead mt-3">
      The Department of Geography at Shah Satnam Ji Girls' College, Sirsa is equipped with a well-furnished Geography Lab. It provides students with hands-on knowledge of physical and human geography, maps, survey instruments and field study techniques.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Geography as a subject in BA</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Dr. Rishu Tomar</td><td>MA Geography (Gold Medalist), Ph.D.</td></tr>
          <tr><td>2</td><td>Ms. Ruby</td><td>MA, B.Ed, Certified in Geoinformatics.</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <ul class="inner-lead">
      <li>Visit to Vita Milk Plant</li>
      <li>Inter-College Quiz Competition</li>
      <li>Industrial Visit to Kuber Agro Industry</li>
    </ul>

  </div>
</div>
